import dayjs from 'dayjs';

export const relativeWhen = (at) => {
  if (!at) return '';
  const d = dayjs(at);
  if (!d.isValid()) return '';
  const now = dayjs();
  if (d.isSame(now, 'day')) return d.format('h:mm A');
  if (d.isSame(now.subtract(1, 'day'), 'day')) return 'Yesterday';
  return d.format(d.isSame(now, 'year') ? 'MMM D' : 'MMM D, YYYY');
};

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : null;
